export default __webpack_public_path__ + "images/48bcb24a4cdfc154c31ceba8b55cef83-down-arrow.svg";